module.exports = __webpack_public_path__ + "img/NL462.2c1960ab.png";